import { Component, OnInit } from '@angular/core';
import { FileSelectionListBaseComponent } from '@app/shared/components/file-upload/file-selection-list-base.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

@Component({
  selector: 'file-selection-thumbnails-list',
  templateUrl: './file-selection-thumbnails-list.component.html',
  styleUrls: ['./file-selection-thumbnails-list.component.scss']
})
export class FileSelectionThumbnailsListComponent extends FileSelectionListBaseComponent implements OnInit {

  constructor(protected componentServiceBundle: ComponentServiceBundle) {
    super(componentServiceBundle);
  }

  public ngOnInit() {
  }

}
